import { t } from 'i18next';
import { supplyUnitEnum } from '../enums';

export const supplyUnitLabels: Record<number, string> = {
    [supplyUnitEnum.FT]: 'flatRate(s)',
    [supplyUnitEnum.J]: 'day(s)',
    [supplyUnitEnum.L]: 'liter(s)',
    [supplyUnitEnum.ML]: 'linearMeter(s)',
    [supplyUnitEnum.T]: 'ton(s)',
    [supplyUnitEnum.TR]: 'ride(s)',
    [supplyUnitEnum.U]: 'unit(s)',
};

export const getSupplyUnitLabel = (state?: number): string => {
    return state !== undefined && supplyUnitLabels[state] ? t(supplyUnitLabels[state]) : '';
};
